import * as R from 'ramda';

import {
    OPEN_DIALOG,
    CLOSE_DIALOG,
    dialogsList
} from './constants';

const defaultDialogState = { open: false, data: {} };
const defaultState = R.mapObjIndexed(() => defaultDialogState, dialogsList);

const dialogsReducer = (state = defaultState, { type, payload }) => {
    switch (type) {
        case OPEN_DIALOG:
            return R.merge(state, { [payload.name]: { open: true, data: payload.data } });
        case CLOSE_DIALOG:
            return R.merge(state, { [payload]: defaultDialogState });
        default:
            return state;
    }
};

export default dialogsReducer;
